(ns teamoesterreich.admin-mode.user.user-card-admin
  (:require [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [goog.date.DateTime]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as v-state]
            [teamoesterreich.admin-mode.data.organisation :as d-organisation]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.data.rights :as d-rights]

            ))



(defonce RIGHTS_LIST d-rights/RIGHTS_LIST)

(defn event-value
  [^js/Event e]
  (h/event-value e))

(defn rights-table [!actual-user]
  (let [!user-rights (r/cursor !actual-user [:user-right])
        _ (d-organisation/get-store-organisations)
        !organisations (r/cursor v-state/app-state [:organisations])
        dep-mask-list (or (d-organisation/get-lv-filter-list @!organisations) [])
        dst-mask-list (reduce (fn [c [k m]] (assoc c k m)) {} (or (d-organisation/get-dest-list @!organisations) []))
        rights (filter :right-active @!user-rights)
        rights (reduce (fn [c e]
                         (let [mask (str (:right-organisationMask e))
                               section (:right-section e)]
                           (conj c (merge e
                                          [:right (or (:name (get RIGHTS_LIST section)) section)]
                                          [:organisationDepartment (d-organisation/get-department-for-key mask dep-mask-list)]
                                          [:organisation (or (get dst-mask-list mask) "-")]
                                          [:right-organisationMask mask]
                                          )))) [] rights)
        ]
    ;(log/debug "rights " (clj->js dst-mask-list) (clj->js rights))
    [mui/table
     [mui/table-head
      [mui/table-row
       [mui/table-cell "Rolle"]
       [mui/table-cell (txt/txt :rights-level 1)]
       [mui/table-cell (txt/txt :rights-level 2)]
       [mui/table-cell (txt/txt :rights-level 3)]
       [mui/table-cell "#"]
       ]]
     [mui/table-body
      (for [rgh (sort-by :right-organisationMask rights)]
        (let [section (:right-section rgh)]
          ^{:key (str "RIGHT_ROW_-" (:right-uuid rgh))}
          [mui/table-row
           [mui/table-cell (or (:name (get (into {} d-rights/RIGHTS_LIST) section)) (str (:right-uuid rgh) " `" section "`"))]
           [mui/table-cell (:organisationMain rgh)]
           [mui/table-cell (:organisationDepartment rgh)]
           [mui/table-cell (:organisation rgh)]
           [mui/table-cell
            [mui/button {:variant "outlined"
                         :onClick (fn []
                                    (d-rights/>edit-right (:right-uuid rgh) {:right-active false}
                                                          #(d-user/actual-user-invalidate !actual-user)))}

             "Löschen"]]
           ]))
      ]

     ]
    ))


(defn add-rights-block [!actual-user !st]
  (let [!right-form (r/cursor !st [:new-right-form])
        !add-admin (r/cursor !st [:add-admin])

        org-list (sort-by second (d-rights/get-my-admin-main))
        org-first (ffirst org-list)
        lv-list (sort-by second (d-rights/get-my-admin-lv (get-in @!right-form [:organizationMain])))
        lv-first (ffirst lv-list)
        dst-list (sort-by first (d-rights/get-my-admin-dst-by-key (get-in @!right-form [:organizationDepartment])))
        dst-first (ffirst dst-list)
        choices (into {} (map (fn [[k v]] [k (:name v)]) (d-rights/get-my-admin-rights)))
        selected_ (or (get-in @!right-form [:rights]) [])]
    ;(log/debug "++++++++++++++++++++++++++++ choices" (clj->js choices))
    (log/debug "++++++++++++++++++++++++++++ main-list" (clj->js org-list) org-first)
    (log/debug "++++++++++++++++++++++++++++ lv-list" (clj->js lv-list) lv-first)
    (log/debug "++++++++++++++++++++++++++++ dst-list" (clj->js dst-list) dst-first)

    [mui/grid
     {:container  true
      :direction  "row"
      :alignItems "flex-start"
      :justify    "flex-start"
      :spacing    1
      :style      {:padding "5px"}}




     [mui/grid
      {:item true
       :xs   12
       }
      [:hr]
      [:h4 "Neues Recht erstellen"]
      ]

     [mui/grid
      {:item true
       :md   4
       :xs   12
       }




      [mui/form-control
       {
        :style     {:background-color (if (:right @!st) "#ffd6d2" "#ffffff")}
        :fullWidth true
        }
       [mui/input-label "Rolle "]
       [mui/select
        {:multiple    true
         :renderValue (fn [vals] (reduce (fn [c e] (str (if (= "" c) "" (str c ","))
                                                        (or (get choices e) e)
                                                        )) "" vals))
         :value       selected_
         :onChange    (fn [e]
                        (let [val (event-value e)]
                          (swap! !right-form assoc :rights val)
                          (log/debug "rights" val (clj->js @!right-form))))
         }

        (let []
          (for [[k v] choices]
            ^{:key (str "RIGHTS_LIST-" k)}
            [mui/menu-item {:value k}
             [mui/list-item-icon [mui/checkbox {:checked (some #{k} selected_)}]]
             [mui/list-item-text v]
             ]
            ))
        ]]]

     [mui/grid
      {:item true
       :md   2
       :xs   12
       }


      [mui/form-control
       {
        :style     {:background-color (if (:organizationMain @!st) "#ffd6d2" "#ffffff")}
        :fullWidth true
        }
       [mui/input-label (txt/txt :rights-level 1)]
       [mui/select
        {:multiple false
         :value    (or (get-in @!right-form [:organizationMain]) "")
         :onChange (fn [val]
                     (swap! !right-form assoc :organizationMain (event-value val)))
         }

        (for [[k v] org-list]
          ^{:key (str "MAIN_LIST-" k)} [mui/menu-item {:value k} v])
        ]]]
     [mui/grid
      {:item true
       :md   2
       :xs   12
       }


      [mui/form-control
       {
        :style     {:background-color (if (:organizationDepartment @!st) "#ffd6d2" "#ffffff")}
        :fullWidth true
        }
       [mui/input-label (txt/txt :rights-level 2)]
       [mui/select
        {:multiple false
         :value    (or (get-in @!right-form [:organizationDepartment]) "")
         :onChange (fn [val]
                     (swap! !right-form assoc :organizationDepartment (event-value val)))
         }

        (for [[k v] lv-list]
          ^{:key (str "DEP_LIST-" k)} [mui/menu-item {:value k} v])
        ]]]

     [mui/grid
      {:item true
       :md   4
       :xs   12
       }

      [mui/form-control
       {
        :style     {:background-color (if (:organization @!st) "#ffd6d2" "#ffffff")}
        :fullWidth true
        }
       [mui/input-label (txt/txt :rights-level 3)]
       [mui/select
        {:multiple false
         :value    (or (get-in @!right-form [:organization]) "")
         :onChange (fn [val]
                     (swap! !right-form assoc :organization (event-value val)))
         }
        (for [[k v] dst-list]
          ^{:key (str "DST_LIST-" k)} [mui/menu-item {:value k} v])
        ]

       ]]


     [mui/grid
      {:item true
       :md   2
       :xs   12
       }

      [mui/button {:style   {:margin "8px 0 0 7px"} :variant "outlined"
                   :color   "secondary"
                   :onClick (fn []
                              (reset! !add-admin false)
                              (reset! !right-form {}))
                   } "Abbrechen"]

      (when (and
              (or (get-in @!right-form [:organization]) (get-in @!right-form [:organizationDepartment]) (get-in @!right-form [:organizationMain]))
              (get-in @!right-form [:rights])
              )

        [mui/button {:style   {:margin "8px 0 0 7px"} :variant "outlined"
                     :color   "primary"
                     :onClick (fn []
                                (d-rights/>add-new {:right-organisationMask (cond
                                                                              (and (get-in @!right-form [:organization]) (not= (get-in @!right-form [:organization]) "")) (get-in @!right-form [:organization])
                                                                              (and (get-in @!right-form [:organizationDepartment]) (not= (get-in @!right-form [:organizationDepartment]) "")) (get-in @!right-form [:organizationDepartment])
                                                                              (and (get-in @!right-form [:organizationMain]) (not= (get-in @!right-form [:organizationMain]) "")) (get-in @!right-form [:organizationMain])
                                                                              )
                                                    :rights-section         (get-in @!right-form [:rights])
                                                    :rights-active          true
                                                    :user-tomId             (:user-tomId @!actual-user)
                                                    }
                                                   (fn []
                                                     (swap! !st assoc :add-admin nil)
                                                     (d-user/actual-user-invalidate !actual-user)
                                                     (reset! !right-form {}))
                                                   ))
                     } "Erstellen"])

      ]

     ]

    ))





(defn get-it [!actual-user !st]
  (let [!add-admin (r/cursor !st [:add-admin])
        !right-form (r/cursor !st [:new-right-form])
        user-rights (get-in @!actual-user [:user-right])
        user-orgId (get-in @!actual-user [:user-orgId])
        user-superUser? (get-in @!actual-user [:user-superUser])
        has-admin? (some? (filter :right-active user-rights))
        ]
    (log/debug "################ admin form !! " (clj->js @!st))
    [mui/card {:style {:textAlign "left"}}
     [mui/card-content
      (cond
        user-superUser? [:h4 {:style {:color "#a31919"}} "Diese Person ist Superuser!"]
        has-admin? [rights-table !actual-user]
        :else [:h4 {:style {:color "#a31919"}} "Diese Person hat keine Admin-Rechte"])

      (when @!add-admin
        [add-rights-block !actual-user !st])
      ]
     [mui/card-actions

      (when (and (not user-superUser?) (not @!add-admin) (d-rights/allow-admin-for d-rights/ADMIN user-orgId))
        [mui/button {:style   {:float         "right"
                               :verticalAlign "middle"
                               :margin-right  "30px"
                               }
                     :onClick (fn []
                                (reset! !right-form {})
                                (reset! !add-admin true)
                                )
                     :color   "primary"
                     :variant "outlined"
                     } (if has-admin? "Admin Role hinzufügen" "Zu Admin machen")])
      ]]
    ))